import '@src/styles/companyInformation/creditcards/creditCardResult.scss';
import { CustomImage, Text } from '@src/components';
import iconSuccess from '@src/assets/icons/icon-success.svg';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

const CreditCardResult = () => {
  const history = useHistory();
  const { editingCard } = useSelector((state) => state?.mobilExpress);

  return (
    <div className="credit-card-result-container">
      <div className="result-content">
        <CustomImage src={iconSuccess} />
        {editingCard?.automaticPayment ? (
          <h3>
            <Text t="yourCreditCardHasBeenSuccessfullyRegisteredFor" />
          </h3>
        ) : (
          <h3>
            <Text t="yourCreditCardHasBeenSuccessfullyRegisteredFor2" />
          </h3>
        )}

        <Button
          id="companyInformation-btn-completed"
          className="btn-completed"
          onClick={() => history.push('/company-information/credit-cards')}
        >
          <Text t="goToCreditCardList" />
        </Button>
      </div>
    </div>
  );
};

export default CreditCardResult;
